<template>
    <div id="FormSpinner">
        <div :class="`form-spinner spinner-align-${localAlign}`">
            <input
                type="text"
                v-model="localFieldLabel"
                placeholder="Bir sayı girin"
                class="spinner-title"
                @input="updateField"
            />
            <div class="spinner">
                <button @click="decrement">-</button>
                <input type="number" v-model="localValue" readonly />
                <button @click="increment">+</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "FormSpinner",
    props: {
        fieldLabel: String,
        align: String,
        item: Object,
        isRequired: Boolean,
    },
    data() {
        return {
            localFieldLabel: this.fieldLabel || "",
            localAlign: this.align || "",
            localValue: this.item.value || 0,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateField() {
            const updateFields = {
                spinner: {
                    fieldLabel: this.localFieldLabel,
                    value: this.localValue,
                    align: this.localAlign,
                    isRequired: this.isRequired,
                },
            };
            this.updateFormField({
                siteId: this.item.siteId,
                formFieldId: this.item._id,
                updateFields: updateFields,
            });
            this.$emit("update-field", updateFields);
        },
        decrement() {
            if (this.localValue > 0) {
                this.localValue--;
                this.updateField();
            }
        },
        increment() {
            this.localValue++;
            this.updateField();
        },
    },
    watch: {
        fieldLabel(newVal) {
            this.localFieldLabel = newVal;
        },
        align(newVal) {
            this.localAlign = newVal;
        },
        "item.value"(newVal) {
            this.localValue = newVal;
        },
    },
};
</script>

<style scoped lang="scss">
#FormSpinner {
    font-family: Avenir, Helvetica, Arial, sans-serif;

    .spinner-align-left {
        display: flex;
        flex-direction: row !important;

        .spinner-title {
            width: auto !important;
            text-align: left;
        }
    }

    .spinner-align-right {
        display: flex;
        flex-direction: row !important;

        .spinner-title {
            width: auto !important;
            text-align: right;
        }
    }

    .form-spinner {
        display: flex;
        flex-direction: column;
        margin: 20px 0;

        .spinner-title {
            display: block;
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 8px;
            border: none;
            padding: 4px;
            width: 100%;
        }

        .spinner {
            display: flex;
            align-items: center;
            border: 1px solid #d3dce6;
            border-radius: 5px;
            overflow: hidden;
            max-width: 100%;
            width: 100%;

            button {
                background-color: #f5f5f5;
                border: none;
                font-size: 1.5em;
                width: 50px;
                cursor: pointer;
                color: #354052;
                padding: 10px;
                flex: none;
            }

            input[type="number"] {
                width: 100%;
                text-align: center;
                border: none;
                font-size: 1.2em;
                padding: 10px;
                flex: 1;
                box-sizing: border-box;
            }
        }
    }
}
</style>
